import { Component, OnInit, ViewChild } from "@angular/core";
import { UtilityService } from "../../services/utility.service";
import { FormControl, FormBuilder, NgForm } from "@angular/forms";
import { CustomerService } from "../../services/customer.service";
import { EnrollmentService } from "../../services/enrollment.service";
import { TripSelectionComponent } from "../../Components/trip-selection/trip-selection.component";
import { TravelerComponent } from "../../Components/traveler/traveler.component";
import {
  MatDialog,
  MatDialogConfig,
  // MatPaginator,
  MatSort,
  MatTabChangeEvent,
  // MatTableDataSource,
} from "@angular/material";
import { Router, ActivatedRoute } from "@angular/router";
import { Observable } from "rxjs";
import { map, startWith, debounceTime, switchMap } from "rxjs/operators";
import { ItineraryComponent } from "../../Components/itinerary/itinerary.component";
import { AllocatePointsService } from "src/app/services/allocate-points.service";
import { PointsOptionBreakUpComponent } from "../../Components/points-option-break-up/points-option-break-up.component";
import { PointsBreakUpComponent } from "../../Components/points-break-up/points-break-up.component";
import { TripEnrollmentNotesComponent } from "../popup/trip-enrollment-notes/trip-enrollment-notes.component";
import { PostTripMiscPointsComponent } from "../popup/post-trip-misc-points/post-trip-misc-points.component";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { SharedServiceService } from "src/app/services/shared-service.service";
import { PostTripPointsBreakupComponent } from "../post-trip-points-breakup/post-trip-points-breakup.component";
@Component({
  selector: "app-trip-enrollment",
  templateUrl: "./trip-enrollment.component.html",
  styleUrls: ["./trip-enrollment.component.css"],
})
export class TripEnrollmentComponent implements OnInit {
  title = "Log";
  showLog = true;
  accountData: any = {};
  model: any = {};
  pointModel: any = {};
  customerList: any = [];
  yearList: any = [];
  selected = new FormControl(1);
  selectedtab = new FormControl(1);
  response: any = {};
  myControl = new FormControl();
  customerId: number = 0;
  parmId = 0;
  enrollmentId: number = 0;
  isProceed = false;
  isEditDAPAdd = false;
  isEditDAP = false;
  isTripAdded = 1;
  sub: any;
  role = +localStorage.getItem("role");
  isEditCompanyInfo = false;
  commonMethodList = [];
  pCustomerList = [];
  custId;
  branchModel: any;
  res: any = {};
  isBranchHold: boolean = false;
  isBranchHoldCurrent: boolean = false;
  isBranchHoldLast: boolean = false;
  isBranchHoldLastToLast: boolean = false;

  displayedColumn: string[] = [
    "logDate",
    "logTime",
    "logUser",
    "tripName",
    "groups",
    "travelerName",
    "changeType",
    "updateDetails",
  ];

  public dataSource = new MatTableDataSource<PointsEntity>();
  public accountsLogdata = new MatTableDataSource<AccountChangeLogModel>();

  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort!: MatSort;

  parentCompanyId: string = "";

  displayPostTripButton = false;
  displayLinkButton = false;
  selectedTabYear: number;
  public mask = [
    "(",
    /[1-9]/,
    /\d/,
    /\d/,
    ")",
    " ",
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ];
  dapAddressModel: {
    dapAddress1: "";
    dapAddress2: "";
    dapAddress3: "";
    dapCity: "";
    dapState: "";
    dapZip: "";
  };
  years = new Date().getFullYear();
  totalRequiredPoints: any = 0.0;
  shortfallPoints: any = 0.0;
  achieved: any = 0.0;

  currentYear = new Date().getFullYear();
  lastYear = new Date().getFullYear() - 1;
  lastToLastYear = new Date().getFullYear() - 2;

  futureYear = new Date().getFullYear() + 1;
  balancePoints: any = 0.0;
  subjectCompanyName = "";
  allEmailTo = "";
  displayPendingAllocationText = false;
  isAllocationPending = 0;
  displayCurrentYearPointInfo = true;

  maxPointsDestination: number = 0;
  maxPoints: number = 0;
  sixtyEligibility: any;
  billEstimate: string = "0.00";
  isIssued: boolean = false;
  xyear: number = new Date().getFullYear() - 1;
  billEstimateModel: any;
  billAmount: any;
  sixtyPercentOfTotalPoints: number = 0;
  enrollmentIds: number = 0;
  isEnrollment = true;
  isAlreadyEnrolled = false;
  currentYears: number = 0;

  constructor(
    private customerService: CustomerService,
    private _router: Router,
    private enrollmentService: EnrollmentService,
    private route: ActivatedRoute,
    private matDialog: MatDialog,
    private _utilityService: UtilityService,
    private fb: FormBuilder,
    private _allocatePointsService: AllocatePointsService,
    private sharedService: SharedServiceService
  ) {}
  defaultSelectedTripYear = JSON.parse(localStorage.getItem("user"))
    .defaultSelectedTripYear;

  ngOnInit() {
    if (this.xyear === 2024) {
      this.sharedService.issued$.subscribe((value) => {
        this.isIssued = value;
      });
    } else {
      this.isIssued = false;
    }

    this.yearList = this._utilityService.fillYear(
      new Date().getFullYear() - 1,
      new Date().getFullYear() + 1
    );
    if (this.defaultSelectedTripYear != null) {
      let index = this.yearList.indexOf(this.defaultSelectedTripYear);
      if (index >= 0) {
        this.years = this.defaultSelectedTripYear;
        this.selected.setValue(index);
      }
    }

    this.commonMethodList = this._utilityService.getCommonMethod();
    this.sub = this.route.params.subscribe((params) => {
      this.enrollmentId = this.parmId = +params["id"]; // (+) converts string 'id' to a number
      this.isTripAdded = +params["isTripAdded"];
      if (params["isAllocationPending"]) {
        this.isAllocationPending = +params["isAllocationPending"];
      } else {
        this.isAllocationPending = 0;
      }
    });

    this.enrollmentIds = this.enrollmentId;
    if (this.enrollmentId > 0) {
      this.enrollmentService
        .getEnrollmentDetail(this.enrollmentId)
        .subscribe((result) => {
          this.isProceed = false;
          this.isEnrollment = false;
          this.model = result;
          this.custId = this.model.customerId;
          this.parentCompanyId = this.model.parentCompany;

          this.yearList = this.yearList.filter(function (y) {
            return y == result.years;
          });
          this.years = this.yearList[0];
          if (!this.years) {
            this.years = result.years;
          }
          this.getCurrentYearPointDetails();
          this.getARStatus3LinkDisplay(this.years, this.custId);

          if (this.custId) {
            this.getBranchhold(this.custId, this.currentYear);
            this.getBranchhold(this.custId, this.lastYear);
            this.getBranchhold(this.custId, this.lastToLastYear);
          }

          this.subjectCompanyName = this.model.companyName.replace("&", "and");

          if (this.model.salesmanEmail) {
            this.allEmailTo = this.model.salesmanEmail;
          }

          if (this.allEmailTo && this.model.branchManageEmail) {
            this.allEmailTo += "; " + this.model.branchManageEmail;
          } else {
            this.allEmailTo = this.model.branchManageEmail;
          }

          if (this.allEmailTo && this.model.groupManagerEmail) {
            this.allEmailTo += "; " + this.model.groupManagerEmail;
          } else {
            this.allEmailTo = this.model.groupManagerEmail;
          }

          if (this.allEmailTo) {
            this.allEmailTo += "; " + "awards@preferredpump.com";
          } else {
            this.allEmailTo = "awards@preferredpump.com";
          }
        });

      if (this.isAllocationPending == 1) {
        this.displayCurrentYearPointInfo = false;
      }

      if (this.isAllocationPending == 0) {
        this.checkPendingAllocationForPreviousYear();
      }
    } else {
      this.enrollmentId = 0;
      this.enrollmentService.getCustomerNameList("").subscribe((result) => {
        this.customerList = result;
      });
    }
    if (this.isTripAdded == 0) {
      this.addTripSelection();
    }
    this.customerService
      .getCustomerNameList("", this.model.parentCompanyId)
      .subscribe((result) => {
        this.pCustomerList = result.filter(
          (x) => x.id != this.model.customerId
        );
      });
    if (+localStorage.getItem("isPoints")) {
      this.selectedtab.setValue(1);
    } else this.selectedtab.setValue(0);
  }
  Checklog() {
    if (this.showLog) {
      this.title = "Back";
    } else {
      this.title = "Log";
    }
    this.showLog = !this.showLog;
  }

  checkPendingAllocationForPreviousYear() {
    this._allocatePointsService
      .getPendingArReleasedCount()
      .subscribe((result: any) => {
        if (result > 0) {
          this.displayPendingAllocationText = true;
        } else {
          this.displayPendingAllocationText = false;
        }
      });
  }
  tripenrollpopup_click() {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = true;
    // dialogConfig.id = "modal-component";
    dialogConfig.width = "700px";
    dialogConfig.data = {
      EnrollmentId: this.enrollmentId,
    };
    const modalDialog = this.matDialog.open(
      TripEnrollmentNotesComponent,
      dialogConfig
    );
    modalDialog.afterClosed().subscribe((result) => {
      if (result) {
        this.response = result;
        this.response.isShow = true;

        // var regex_newline = new RegExp("(\r\n|\r|\n)");

        this.model.enrollmenNotes = result.notes.replace(
          /(?:\r\n|\r|\n)/g,
          "<br>"
        );
      }
    });
  }

  iSProceed = true;
  changeTab(index: number) {
    this.response = { isShow: false };
    //this.iSProceed = false;
    if (this.parmId) {
    } else {
      this.years = this.yearList[index];
      this.enrollmentId = 0;
      this.customerId = 0;
      this.isEnrollment=true;
      //this.selected.setValue(index);
    }
  }

  private typed(value: string) {
    if (value.length >= 3) {
      var emptlist = [{ id: 0, customerName: "No data found" }];
      this.customerList = [];
      this.enrollmentService.getCustomerNameList(value).subscribe((result) => {
        if (result && result.length > 0) this.customerList = result;
        else this.customerList = emptlist;
      });
    }
  }

  private select(value: number) {
    if (value > 0) {
      this.customerId = value;
      this.custId = value;
      this.isProceed = true;
    }
  }

  proceed() {
    this.enrollmentService
      .proceedEnrollments(this.customerId, this.years)
      .subscribe((result) => {
        if (result.messageCode == "1") {
          this.model = result.data;
          this.custId = this.model.customerId;
          this.customerId = this.model.customerId;
          this.isProceed = false;
          this.isEnrollment = false;
          this.getCurrentYearPointDetails();
          this.getARStatus3LinkDisplay(this.years, this.customerId);

          // Get enrollment ID for the selected year
          this.GetEnrollmetId(this.customerId, this.years);

          // Check if this is an existing enrollment
          if (result.data.id > 0) {
            this.enrollmentId = result.data.id;
            this.enrollmentIds = result.data.id;
            this.currentYears = this.model.years;

            // If enrollment exists, check if it has trip selections
            if (this.model.isTripAdded) {

              // Set flag to indicate this is an existing enrollment
              this.isAlreadyEnrolled = true;
            }
          }

          this.GetEnrollmetDetailForLastTwoYears(
            this.customerId,
            this.lastYear
          );
          this.GetEnrollmetDetailForLastTwoYears(
            this.customerId,
            this.lastToLastYear
          );
        } else {
          this.response = result;
        }
      });
  }
  GetEnrollmetId(CustomerId: number, years: number) {
    this.enrollmentService
      .proceedEnrollment(CustomerId, years)
      .subscribe((enrollmentResult) => {
        if (enrollmentResult.messageCode == "1") {
          // Store original enrollment ID
          const originalEnrollmentId = this.model.id;

          // Update model with latest data
          this.model = enrollmentResult.data;
          this.enrollmentId = this.model.id;
          this.enrollmentIds = this.model.id;
          this.currentYears = this.model.years;
          this.isEnrollment = false;

          // Check if this is an existing enrollment with trip selections
          if (this.model.isTripAdded) {
            this.isAlreadyEnrolled = true;

          }
        } else if (enrollmentResult.messageCode == "2") {
          this.response = enrollmentResult;
          this.response = { isShow: false, message: "" };
        }
      });
  }

  GetEnrollmetDetailForLastTwoYears(CustomerId: number, years: number) {
    this.enrollmentService
      .proceedEnrollment(CustomerId, years)
      .subscribe((enrollmentResult) => {
        if (enrollmentResult.messageCode == "1") {
          this.model = enrollmentResult.data;
          this.enrollmentId = this.model.id;
          this.isEnrollment = false;
        } else if (enrollmentResult.messageCode == "2") {
          this.response = enrollmentResult;
          this.response = { isShow: false, message: "" };
        }
      });
  }

  addTripSelection() {
    if (this.enrollmentIds > 0 && this.currentYears === this.years) {
      this.addTripSelections(this.enrollmentIds);
    } else if (this.enrollmentId > 0 && this.model.years === this.years) {
      this.addTripSelections(this.enrollmentId);
    } else {
      this.addTripSelectionProceed();
    }
  }
  addTripSelectionProceed() {
    if (!this.customerId || !this.years) {
      console.warn(
        "Invalid parameters for proceedEnrollment:",
        this.customerId,
        this.years
      );
      return;
    }
    this.response = { isShow: false };
    // this.isProceed = true;
    this.enrollmentService
      .getTripSelections(this.customerId, this.years)
      .subscribe((result: any) => {
        //this.model = result;

        if (!result) {
          console.warn("No trip selections found. Modal will not open.");
          return;
        }

        result.displayLinkButton = this.displayLinkButton; // GET AR Status
        result.years = this.years;
        result.customerId = this.customerId;
        result.enrollmentId = this.model.id;
        const dialogConfig = new MatDialogConfig();
        // The user can't close the dialog by clicking outside its body
        dialogConfig.disableClose = true;
        // dialogConfig.id = "modal-component";
        dialogConfig.width = "650px";
        dialogConfig.data = result;
        const modalDialog = this.matDialog.open(
          TripSelectionComponent,
          dialogConfig
        );

        modalDialog.afterClosed().subscribe((result) => {
          if (result) {
            this.response = result;
            if (result.messageCode == "1") {
              // && !this.parmId

              if (+localStorage.getItem("isPoints")) {
                this._router.navigate([
                  "/trip-enrollment-detail/" + this.enrollmentId,
                ]);
              } else {
                localStorage.setItem(
                  "tripOptionUpdate",
                  JSON.stringify(result)
                );
                this._router.navigate(["/trip-enrollment"]);
              }
            }
          }
        });
      });
  }
  addDAPAddress() {
    this.dapAddressModel = this.model;
    this.model.dapAddress1 = "";
    this.model.dapAddress2 = "";
    this.model.dapAddress3 = "";
    this.model.dapCity = "";
    this.model.dapState = "";
    this.model.dapZip = "";
    this.isEditDAPAdd = true;
  }
  cancelDAPAddress() {
    // this.dapAddressModel =this.model;
    this.model.dapAddress1 = this.dapAddressModel.dapAddress1;
    this.model.dapAddress2 = this.dapAddressModel.dapAddress2;
    this.model.dapAddress3 = this.dapAddressModel.dapAddress3;
    this.model.dapCity = this.dapAddressModel.dapCity;
    this.model.dapState = this.dapAddressModel.dapState;
    this.model.dapZip = this.dapAddressModel.dapZip;
    this.isEditDAPAdd = false;
  }
  updateDAPAddress(form: NgForm) {
    if (form.valid) {
      //this.enrollmentService.updateDAPAddress(this.model).subscribe((result) => {
      this.customerService
        .updateCustomerDAPAddress(this.model)
        .subscribe((result) => {
          if (result) {
            this.response = result;
            if (result.messageCode == 1) {
              //this.dapAddressModel = this.model;
              this.isEditDAPAdd = false;
            }
          }
        });
    } else {
      let invalidFields = [].slice.call(
        document.getElementsByClassName("ng-invalid")
      );
      if (invalidFields[1]) {
        if (invalidFields[2]) invalidFields[2].focus();
        invalidFields[1].focus();
        return;
      }
    }
  }

  updatedCustomerDAP(form: NgForm) {
    if (form.valid) {
      this.customerService
        .updatedCustomerDAP(this.model)
        .subscribe((result) => {
          if (result) {
            this.response = result;
            if (result.messageCode == 1) {
              this.isEditDAP = false;
            }
          }
        });
    } else {
      let invalidFields = [].slice.call(
        document.getElementsByClassName("ng-invalid")
      );
      if (invalidFields[1]) {
        if (invalidFields[2]) invalidFields[2].focus();
        invalidFields[1].focus();
        return;
      }
    }
  }

  addTripSelections(enrollmentId: number) {
    this.response = { isShow: false };
    this.enrollmentService
      .getTripSelection(enrollmentId)
      .subscribe((result: any) => {
        //this.model = result;
        result.displayLinkButton = this.displayLinkButton; // GET AR Status
        result.years = this.years;
        result.customerId = this.model.customerId;
        //result.locked = true;
        const dialogConfig = new MatDialogConfig();
        // The user can't close the dialog by clicking outside its body
        dialogConfig.disableClose = true;
        // dialogConfig.id = "modal-component";
        dialogConfig.width = "650px";
        dialogConfig.data = result;
        const modalDialog = this.matDialog.open(
          TripSelectionComponent,
          dialogConfig
        );

        modalDialog.afterClosed().subscribe((result) => {
          if (result) {
            this.response = result;
            if (result.messageCode == "1") {
              // && !this.parmId

              if (+localStorage.getItem("isPoints")) {
                this._router.navigate([
                  "/trip-enrollment-detail/" + this.enrollmentId,
                ]);
              } else {
                localStorage.setItem(
                  "tripOptionUpdate",
                  JSON.stringify(result)
                );
                this._router.navigate(["/trip-enrollment"]);
              }
            }
          }
        });
      });
  }

  addTraveler() {
    if (this.enrollmentIds > 0 && this.currentYears === this.years) {
      this.addTravelers(this.enrollmentIds);
    } else if (this.enrollmentId > 0 && this.model.years === this.years) {
      this.addTravelers(this.enrollmentId);
    }
  }

  addTravelers(enrollmentId) {
    this.response = { isShow: false };
    this.enrollmentService
      .getTripList(enrollmentId)
      .subscribe((result) => {
        //this.model = result;
        //added on 27/09
        result.displayLinkButton = this.displayLinkButton;
        result.years = this.years;

        result.lastToLastYear = this.lastToLastYear;
        if (this.lastYear === this.years) {
          result.lastYear = this.lastYear;
        } else {
          result.currentYear = this.currentYear;
        }

        const dialogConfig = new MatDialogConfig();
        // The user can't close the dialog by clicking outside its body
        dialogConfig.disableClose = true;
        // dialogConfig.id = "modal-component";
        dialogConfig.width = "1250px";
        dialogConfig.data = result;
        const modalDialog = this.matDialog.open(
          TravelerComponent,
          dialogConfig
        );

        modalDialog.afterClosed().subscribe((result) => {
          if (result) {
            this.response = result;
            if (result.messageCode == 1 && this.parmId) {
              localStorage.setItem("tripOptionUpdate", JSON.stringify(result));
              this._router.navigate(["/trip-enrollment"]);
            }
          }
        });
      });
  }

  addItinerary() {
    this.response = { isShow: false };
    this.enrollmentService
      .getTripList(this.enrollmentId)
      .subscribe((result) => {
        //this.model = result;

        //added on 27/09
        result.displayLinkButton = this.displayLinkButton;
        result.years = this.years;
        if (this.lastYear === this.years) {
          result.lastYear = this.lastYear;
        } else {
          result.currentYear = this.currentYear;
        }
        const dialogConfig = new MatDialogConfig();
        // The user can't close the dialog by clicking outside its body
        dialogConfig.disableClose = true;
        // dialogConfig.id = "modal-component";
        dialogConfig.width = "1250px";
        dialogConfig.data = result;
        const modalDialog = this.matDialog.open(
          ItineraryComponent,
          dialogConfig
        );

        modalDialog.afterClosed().subscribe((result) => {
          if (result) {
            this.response = result;
            if (result.messageCode == 1 && this.parmId) {
              localStorage.setItem("tripOptionUpdate", JSON.stringify(result));
              this._router.navigate(["/trip-enrollment"]);
            }
          }
        });
      });
  }

  deleteEnrollment() {
    this.response = { isShow: false };
    if (confirm("Are you sure you want to delete this trip enrollment?")) {
      this.enrollmentService
        .deleteEnrollment(this.enrollmentId, this.custId)
        .subscribe((result) => {
          this.response = result;
          if (this.response.messageCode == 1) {
            // debugger;
            localStorage.setItem("deleteEnroll", "1");
            this._router.navigate(["/trip-enrollment"]);
          }
        });
    }
  }

  removeDAPAddress() {
    this.response = { isShow: false };
    if (confirm("Are you sure you want to delete this dap address?")) {
      this.model.dapAddress1 = "";
      this.model.dapAddress2 = "";
      this.model.dapAddress3 = "";
      this.model.dapCity = "";
      this.model.dapState = "";
      this.model.dapZip = "";
      this.model.IsDeleteDapAddress = true;
      this.customerService
        .updateCustomerDAPAddress(this.model)
        .subscribe((result) => {
          this.response = result;
          if (result) {
            if (result.messageCode == 1) {
              this.isEditDAPAdd = false;
            }
          }
        });
    }
  }

  updatedCompanyInfo(form: NgForm) {
    if (form.valid) {
      if (!this.model.lastYearSales) this.model.lastYearSales = 0;
      this.model.LogUserId = this._utilityService.getCurrentUserId();
      this.customerService
        .updatedCompanyInfo(this.model)
        .subscribe((result) => {
          if (result) {
            this.response = result;
            if (result.messageCode == 1) {
              this.isEditCompanyInfo = false;
              this.enrollmentService
                .getEnrollmentDetail(this.enrollmentId)
                .subscribe((result) => {
                  this.model = result;
                });
            }
          }
        });
    } else {
      let invalidFields = [].slice.call(
        document.getElementsByClassName("ng-invalid")
      );
      if (invalidFields[1]) {
        if (invalidFields[2]) invalidFields[2].focus();
        invalidFields[1].focus();
        return;
      }
    }
  }

  private typedP(value: string) {
    if (value.length >= 3) {
      var emptlist = [{ id: 0, customerName: "No data found" }];
      this.pCustomerList = [];
      this.customerService
        .getCustomerNameList(value, this.model.parentCompanyId)
        .subscribe((result) => {
          if (result && result.length > 0) this.customerList = result;
          else this.pCustomerList = emptlist;
        });
    }
  }
  public displayedColumns = [
    "category",
    "destination",
    "trips",
    "points",
    "pointsOption",
    "total",
  ];
  public tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    this.response = { isShow: false, message: "" };
    // if (tabChangeEvent.index == 1) {
    //   debugger;
    //   this.getCurrentYearPointDetails();
    // }
    // Display Post Trip /Misc. Point Button for Last & Current Year

    this.selectedTabYear = 0;
    var _currentYear = new Date().getFullYear();
    var _lastYear = _currentYear - 1;
    if (tabChangeEvent.index == 2) {
      this.selectedTabYear = _lastYear;
    }
    if (tabChangeEvent.index == 3) {
      this.selectedTabYear = _currentYear;
    }
    if (tabChangeEvent.index == 3) {
      this.getARStatus(this.selectedTabYear, this.custId);
      this.getCurrentYearPointDetails();
    } else {
      this.displayPostTripButton = false;
    }
    this.showLog =
      tabChangeEvent.index === 1 ||
      tabChangeEvent.index === 2 ||
      tabChangeEvent.index === 3;
    this.title = this.showLog ? "Log" : "Back";
  }
  getCurrentYearPointDetails() {
    this._allocatePointsService
      .getCustomerWisePointsAllocation(this.enrollmentId, this.currentYear)
      .subscribe((result) => {
        this.pointModel = result;
        // this.isIssued = this.pointModel.isIssued;

        this.dataSource.data = this.pointModel
          .allocatedPointList as PointsEntity[];
        if (this.pointModel && this.pointModel.allocatedPointList.length > 0) {
          this.totalRequiredPoints = this.pointModel.allocatedPointList
            .map((a) => a.total)
            .reduce(function (a, b) {
              return (parseFloat(a) + parseFloat(b)).toFixed(2);
            });
        }
        //Max Points for Destination
        if (this.pointModel && this.pointModel.allocatedPointList.length > 0)
        {
          let maxPoint = this.pointModel.allocatedPointList.reduce(
          (prev, current) =>
            parseFloat(current.points) > parseFloat(prev.points)
              ? current
              : prev
        );
        this.maxPointsDestination = maxPoint.destination;
        this.maxPoints = maxPoint.points;

        this.sixtyPercentOfTotalPoints = this.maxPoints * 0.6;
        this.sixtyEligibility = (
          (this.pointModel.lastYearBalance * 100) /
          this.sixtyPercentOfTotalPoints
        ).toFixed(2);
        }

        this.calculateBillEstimates(
          this.pointModel.customerId,
          this.currentYear,
          +this.pointModel.lastYearBalance
        );
        this.balancePoints = (
          +this.pointModel.lastYearRollOverPoints +
          +this.pointModel.lastYearEarnPoints -
          +this.pointModel.postTripPoints
        ).toFixed(2);

        this.shortfallPoints = (
          this.totalRequiredPoints -
          this.balancePoints -
          this.pointModel.postTripPoints
        ).toFixed(2);
        let achievedPT =
          (this.pointModel.lastYearBalance * 100) / this.totalRequiredPoints;
        achievedPT = isNaN(achievedPT) ? 0 : achievedPT;
        this.achieved = achievedPT > 100 ? 100.0 : achievedPT.toFixed(2);
        // If Achieved Point is in -ve
        if (this.achieved < 0) {
          this.achieved = 100.0;
        }
      });
  }

  calculateBillEstimates(
    customerId: number,
    years: number,
    availablePoints: number
  ) {
    this._allocatePointsService
      .getBillEstimate(customerId, years, availablePoints)
      .subscribe((result) => {
        this.billEstimateModel = result;
        if(this.billEstimateModel != null){
        this.billAmount = this.billEstimateModel.billAmount
        }

      });
  }

  getPointsOptionBreakUp(tripId: number, destination: string) {
    this._allocatePointsService
      .getPointsOptionBreakUp(tripId, this.pointModel.customerId)
      .subscribe((result) => {
        let data = { destination: destination, pointList: result };
        const dialogConfig = new MatDialogConfig();
        // The user can't close the dialog by clicking outside its body
        dialogConfig.disableClose = true;
        // dialogConfig.id = "modal-component";
        dialogConfig.width = "650px";
        dialogConfig.data = data;
        this.matDialog.open(PointsOptionBreakUpComponent, dialogConfig);
      });
  }
   getPostTripPointsBreakUp() {
    this._allocatePointsService
      .PostTripPointsOptionBreakUp(this.custId, this.currentYear)
      .subscribe((result) => {
        const data = {
        customerId: this.custId,
        year: this.currentYear,
        pointList: result
      };
        const dialogConfig = new MatDialogConfig();
        // The user can't close the dialog by clicking outside its body
        dialogConfig.disableClose = true;
        // dialogConfig.id = "modal-component";
        dialogConfig.width = "650px";
        dialogConfig.data = data;
        this.matDialog.open(PostTripPointsBreakupComponent, dialogConfig);
      });
  }

  getPointsBreakUp() {
    let data = {
      lastYearRollOverPoints: this.pointModel.lastYearRollOverPoints,
      lastYearEarnPoints: this.pointModel.lastYearEarnPoints,
      postTripPoints: this.pointModel.postTripPoints,
      lastYearBalance: this.pointModel.lastYearBalance,
      lastYearChildPoints: this.pointModel.lastYearChildPoints,
      isCustomerChildCompany: this.pointModel.isCustomerChildCompany,
      parentCustomerNumber: this.pointModel.parentCustomerNumber,
    };
    //this.model = result;
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = true;
    // dialogConfig.id = "modal-component";
    dialogConfig.width = "350px";
    dialogConfig.data = data;
    this.matDialog.open(PointsBreakUpComponent, dialogConfig);
  }

  getARStatus(years, customerId) {
    this._allocatePointsService
      .getARStatusByCustomerIdAndYear(years, customerId)
      .subscribe((result: any) => {
        if (result.messageCode == 1) {
          this.displayPostTripButton = !result.data;
        } else {
          this.displayPostTripButton = true;
        }
      });
  }

  getARStatus3LinkDisplay(years, customerId) {
    //debugger;
    this._allocatePointsService
      .getARStatusByCustomerIdAndYear(years, customerId)
      .subscribe((result: any) => {
        if (result.messageCode == 1) {
          this.displayLinkButton = !result.data;
        } else {
          this.displayLinkButton = true;
        }
      });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  SavePostTripAndMiscPoint() {
    // debugger;
    let data = {
      years: this.selectedTabYear,
      customerId: this.custId,
      ppeWhsCode: this.model.ppewhsCodeString,
    };

    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = true;
    // dialogConfig.id = "modal-component";
    dialogConfig.width = "auto";
    dialogConfig.minWidth = "500px";
    dialogConfig.data = data;
    const modalDialog = this.matDialog.open(
      PostTripMiscPointsComponent,
      dialogConfig
    );

    modalDialog.afterClosed().subscribe({
      next: (data) => {
        if (data) {
          this.response = data;
          // Update the AR Release status to released
          if (this.response.messageCode === 1) {
            this.getCurrentYearPointDetails();
          }
        }
      },
    });
  }

  getBranchhold(custId: number, years: number) {
    this.enrollmentService.getBranchHold(custId, years).subscribe((result) => {
      const isHold = result && result.isBranchHold ? result.isBranchHold : false;
      if (years === this.currentYear) {
        this.isBranchHoldCurrent = isHold;
      } else if (years === this.lastYear) {
        this.isBranchHoldLast = isHold;
      } else if (years === this.lastToLastYear) {
        this.isBranchHoldLastToLast = isHold;
      }
    });
  }

  BranchHoldSave(year: number) {
    let isHold = false;

    if (year === this.currentYear) {
      isHold = this.isBranchHoldCurrent;
    } else if (year === this.lastYear) {
      isHold = this.isBranchHoldLast;
    } else if (year === this.lastToLastYear) {
      isHold = this.isBranchHoldLastToLast;
    }

    const payload = {
      customerId: this.custId,
      years: year,
      isBranchHold: isHold ? 1 : 0,
      logUserId: this._utilityService.getCurrentUserId(),
    };
    this.enrollmentService.branchHold(payload).subscribe((res) => {
      if (res.messageCode == 1) {
        this.response = res;
        this.response = { isShow: false };
      } else if (res.messageCode == 2) {
        this.response = res;
        this.response = {
          message:
            "The trip is not linked to the selected year. Please assign the trip before updating the branch hold.",
          isShow: true,
        };
      } else {
        this.response = res;
      }
    });
  }
  isEnrollmentForCurrentYear(): boolean {
  return this.enrollmentId > 0 && this.model.years === this.years;
}
}
export interface PointsEntity {
  category: string;
  destination: string;
  trips: string;
  points: string;
  pointsOption: string;
  total: string;
  balance: string;
  pointType: number;
}

export interface AccountChangeLogModel {
  logDate: string;
  logTime: string;
  logUser: string;
  tripName: string;
  groups: string;
  travelerName: string;
  changeType: string;
  updateDetails: string;
}
